import { render, staticRenderFns } from "./ScrollMarquee.vue?vue&type=template&id=74ed2d02&"
import script from "./ScrollMarquee.vue?vue&type=script&lang=js&"
export * from "./ScrollMarquee.vue?vue&type=script&lang=js&"
import style0 from "./ScrollMarquee.vue?vue&type=style&index=0&id=74ed2d02&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports